import * as Sentry from '@sentry/react'
import { env } from './env'

// Virheet menevät GlitchTipiin (Sentry-yhteensopiva, itse hostattu); DSN tulee
// build-aikaisesta VITE_SENTRY_DSN-muuttujasta. Replay ja profilointi eivät ole
// käytössä: GlitchTip pudottaa ne hiljaa, eikä ruudun sisältöä haluta tallentaa.
export function initSentry() {
  if (!env.sentryDsn) return

  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.environment,
    release: env.gitSha !== 'local' ? `charging-portal@${env.gitSha}` : undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: env.isProd ? 0.2 : 1.0,
    // Ei käyttäjätunnisteita (IP, sähköposti) virhetapahtumiin
    sendDefaultPii: false,
  })
}
